<template>
  <Modal v-model="isOpen" :close="() => { setModal(false) }">
    <div class="lcu-modal">
      <div class="row row-center" v-if="loading">
        <spin-loader />
      </div>
      <div v-if="!loading">
        <div class="row row-center">
          <p>
            ¿Estás seguro de que quieres volver a hacer este examen ahora?
          </p>
        </div>
        <div class="row" v-if="retakeError">
            <span class="lcu-danger-text">{{ retakeError }}</span>
        </div>
        <div class="row">
            <button-cta
                :text="'Sí, rehacer ahora'"
                @on-click="onRetake" />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import SpinLoader from 'ç/loaders/spin/Spin.vue';
import ButtonCta from 'ç/buttons/Cta.vue';

export default {
  name: 'retake-exam-modal',
  components: {
    SpinLoader,
    ButtonCta,
  },
  props: [
    'is-open',
    'onRetake',
    'retakeError',
    'loading',
  ],
  methods: {
    setModal(val) {
      this.$emit('set-modal', val);
    },
  },
};
</script>
